import React from 'react'

import PageSection from './PageSection'

const DotsBannerSection = ({ title, content, extraContent }) => (
  <PageSection extraClass='dots-banner-section white relative py4'>
    <div className='col-10 md-col-12 maxw-medium bg-primary mx-auto center p3 mb3'>
      {title && <h2 className='h2 mb3'>{title}</h2>}
      {content && (
        <p
          className='dots-banner-section__subtitle text-para text-para--light bg-primary maxw-text mx-auto p1'
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {extraContent && extraContent}
    </div>
  </PageSection>
)

export default DotsBannerSection



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/DotsBannerSection.js